import React, { useState, useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import dbService from '../../../services/dbService';
import { Eye } from 'react-bootstrap-icons';
import PageContainer from '../../layout/PageContainer';

const CaseList = () => {
  const [cases, setCases] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');

  useEffect(() => {
    const fetchCases = async () => setCases(await dbService.getAll('cases'));
    fetchCases();
  }, []);

  const filteredCases = useMemo(() => {
    return cases
      .filter(c => statusFilter === 'All' || c.status === statusFilter)
      .filter(c => 
        c.customerName.toLowerCase().includes(searchTerm.toLowerCase()) || 
        String(c.id).includes(searchTerm)
      );
  }, [cases, searchTerm, statusFilter]);
  
  const uniqueStatuses = ['All', ...new Set(cases.map(c => c.status))];

  return (
     <PageContainer title="Case Management Queue">
        <div className="card mt-4">
          <div className="card-header">
            <div className="row g-3 align-items-center">
              <div className="col-md-6">
                <input 
                  type="text" 
                  className="form-control" 
                  placeholder="Search by Customer or Case ID..."
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <div className="input-group">
                  <label className="input-group-text" htmlFor="statusFilter">Status</label>
                  <select className="form-select" id="statusFilter" value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
                    {uniqueStatuses.map(status => <option key={status} value={status}>{status}</option>)}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover align-middle">
                <thead>
                  <tr>
                    <th>Case ID</th><th>Customer Name</th><th>Risk</th><th>Status</th><th>Assigned To</th><th>Open Date</th><th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCases.length > 0 ? filteredCases.map(c => (
                    <tr key={c.id}>
                      <td><code>{c.id}</code></td>
                      <td><Link to={`/kyc-profile/${c.customerId}`}>{c.customerName}</Link></td>
                      <td><span className={`badge text-bg-${c.risk === 'High' ? 'danger' : c.risk === 'Medium' ? 'warning' : 'secondary'}`}>{c.risk}</span></td>
                      <td>{c.status}</td>
                      <td>{c.assignedTo}</td>
                      <td>{c.openDate}</td>
                      <td><Link to={`/case-management/${c.id}`} className="btn btn-sm btn-outline-primary"><Eye /></Link></td>
                    </tr>
                  )).reverse() : (
                    <tr>
                      <td colSpan="7" className="text-center text-muted">No cases found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </PageContainer> 
    );
};

export default CaseList;